// Utility function for consistent RFZO price formatting
export const formatRFZOPrice = (
  price: number | string | null | undefined,
  hasNullValues: boolean = false
): string => {
  const numericPrice = Number(price);

  if (price === null || price === undefined || isNaN(numericPrice)) {
    return "N/A";
  }

  if (numericPrice === 0) {
    return hasNullValues ? "0 RSD*" : "0 RSD";
  }

  if (numericPrice < 0) {
    return "Greška";
  }

  const formattedPrice = `${numericPrice.toLocaleString("sr-Latn-RS")} RSD`;
  return hasNullValues ? `${formattedPrice}*` : formattedPrice;
};

// Calculate total price across items and collect null statistics
export const calculateTotalRFZOPrice = (
  items: Array<{ itemResponse?: { rfzoPrice?: number | string | null } }>
): { total: number; nullCount: number; itemCount: number } => {
  let total = 0;
  let nullCount = 0;

  items.forEach((item) => {
    const price = item.itemResponse?.rfzoPrice;
    const numericPrice = Number(price);

    if (price !== null && price !== undefined && !isNaN(numericPrice)) {
      total += numericPrice;
    } else {
      nullCount++;
    }
  });

  return {
    total,
    nullCount,
    itemCount: items.length,
  };
};

// Helper to build tooltip text depending on data completeness
export const createPriceTooltip = (
  availableCount: number,
  totalCount: number,
  hasNullValues: boolean
): string => {
  if (!hasNullValues) {
    return "Ukupna RFZO cena za sve artikle";
  }

  if (availableCount === 0) {
    return "RFZO cena nije dostupna za artikle";
  }

  return `RFZO cena za ${availableCount} od ${totalCount} artikala. Neki artikli nemaju dostupnu cenu.`;
};
